module.exports = __webpack_public_path__ + "static/media/step-10.3438e8eb.png";